<script>
import Layout from '@/components/layout/app-layout'
import appConfig from '@/app.config'
import PageHeader from '@/components/layout/page-header'
import tableMixin from '@/mixins/table'
import api from '@/helpers/api'
import { prettyBytes } from '@/helpers/filters/pretty-bytes'
/**
 * my orders list  Component
 */
export default {
  name: 'sales.web-orders.list',
  page: {
    title: 'Web Orders',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  computed: {
    breadcrumbs () {
      return [
        {
          text: 'My Orders',
          active: true
        }
      ]
    }
  },

  mixins: [tableMixin],
  props: {
    length: { type: Number, default: 5 }
  },
  data () {
    return {
      title: 'My Orders',
      isLoading: false,
      search: null,

      fields: [
        {
          key: 'date',
          label: 'Date',
          thStyle: { width: '80px' }
        },
        {
          key: 'type',
          label: 'Item'
        },
        {
          key: 'reference',
          label: 'Reference'
        },
        {
          key: 'shipping',
          label: 'Shipping'
        },
        {
          key: 'quantity',
          label: 'Qty.',
          class: 'text-center',
          thStyle: { width: '80px' }
        },
        {
          key: 'status',
          label: 'Status',
          thStyle: { width: '80px' }
        }
      ]
    }
  },
  created () {
    this.onRefresh()
  },
  mounted () {
    this.onRefresh()
  },
  watch: {
    search: 'onRefresh',
    currentPage: 'onRefresh',
    perPage: 'onRefresh',
    '$route.query': 'onRefresh'
  },
  methods: {
    async onRefresh () {
      this.isLoading = true
      let filters = [{ is_submitted: { _eq: true } }]

      if (this.$route.query.status)
        filters = [...filters, { status: { _eq: this.$route.query.status } }]

      let { items, total_rows } = await api.webForms.fetchPage({
        page: this.currentPage,
        pageSize: this.perPage === 'All' ? -1 : this.perPage,
        filters,
        needle: this.search,
        orderBy: { submitted_at: 'desc' }
      })

      this.data = items
      this.totalRows = total_rows
      this.isLoading = false
    },
    onRowClickedHandler (item, index, event) {
      this.$router.push({
        name: 'sales.my-orders.view',
        params: { id: item.id }
      })
    },
    fileTooltip (file) {
      var size = prettyBytes(file.file_size)
      return (
        '<strong>' +
        file.file_name +
        '</strong><small class="mx-2">' +
        size +
        '</small>'
      )
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="breadcrumbs" />
    <div class="row">
      <div class="col-12">
        <b-card class="mb-0 shadow-sm rounded">
          <div class="mb-4 d-flex justify-content-end align-items-center">
            <g-search-input
              v-model="search"
              placeholder="Find Orders"
              width="300px"
              class="mr-0 ml-2"
            />
            <b-btn variant="link" v-on:click="onRefresh"
              ><i class="fas fa-sync"></i
            ></b-btn>
          </div>

          <b-card-body class="p-0">
            <!-- Table data -->
            <b-table
              show-empty
              hover
              outlined
              :items="data"
              :fields="fields"
              :busy="isLoading"
              head-variant="white"
              class="table-centered"
              stacked="md"
              tbody-tr-class="pointer"
              v-on:row-clicked="onRowClickedHandler"
            >
              <template v-slot:cell(date)="{ item }">
                {{ item.submitted_at | moment('DD/MM/YYYY') }}
              </template>
              <template v-slot:cell(type)="{ item }">
                <div class="d-flex justify-content-start align-items-center">
                  <span class="text-truncate">{{
                    item.item.short_description
                  }}</span>

                  <template v-if="item.form_data.is_remill">
                    <i
                      :id="`ttRemill${item.id}`"
                      class="mdi mdi-alpha-r-box text-primary font-size-16 ml-2"
                    ></i>
                    <b-tooltip
                      :target="`ttRemill${item.id}`"
                      variant="dark"
                      placement="right"
                    >
                      {{ $t('Remill') }}
                    </b-tooltip>
                  </template>
                  <template v-if="!!item.file">
                    <i
                      :id="`ttFile${item.file_id}${item.id}`"
                      class="mdi mdi-file-check-outline text-primary font-size-16 ml-2"
                    ></i>
                    <b-tooltip
                      :target="`ttFile${item.file_id}${item.id}`"
                      variant="dark"
                      title="File"
                      placement="right"
                    >
                      <strong>
                        {{ item.file.file_name }}
                      </strong>
                      <small class="mx-2">{{
                        item.file.file_size | prettyBytes
                      }}</small>
                    </b-tooltip>
                  </template>
                </div>

                <small v-if="item.form_data.hasOwnProperty('model_type')">
                  {{ $t(`attribute.model_type.${item.form_data.model_type}`) }}
                </small>
              </template>

              <template v-slot:cell(reference)="{ item }">
                <span v-if="!!item.reference">{{ item.reference }}</span>
                <span v-else>{{ $t(`no reference`) }}</span>
                <br />
                <span
                  class="small m-0"
                  v-if="item.form_data.hasOwnProperty('foam_type')"
                  :id="`ttFoamType${item.id}`"
                >
                  {{ $t(`attribute.foam_type.${item.form_data.foam_type}`) }}
                </span>
                <b-tooltip
                  v-if="
                    item.form_data.hasOwnProperty('foam_type') &&
                    item.form_data.foam_type === 'mix'
                  "
                  :target="`ttFoamType${item.id}`"
                  variant="dark"
                  placement="right"
                  custom-class="text-left"
                  style="min-width: 300px"
                >
                  <p class="mx-2 my-0">
                    {{ $t('Seat') }}:
                    {{
                      $t(
                        `attribute.foam_type.${item.form_data.mix_seat_foam_type}`
                      )
                    }}<br />
                    {{ $t('Back') }}:
                    {{
                      $t(
                        `attribute.foam_type.${item.form_data.mix_back_foam_type}`
                      )
                    }}
                  </p>
                </b-tooltip>
              </template>

              <template v-slot:cell(status)="{ item }">
                <app-status-badge :status="item.status" />
              </template>

              <template v-slot:cell(shipping)="{ item }">
                <p class="m-0 text-muted" v-if="item.shipping_address">
                  <i class="mdi mdi-cube-send text-muted mr-1 font-size-18"></i>
                  {{ item.shipping_address.company_name }},
                  {{ item.shipping_address.city }} ({{
                    item.shipping_address.country_code
                  }})
                </p>
                <p v-else class="m-0 text-muted">{{ $t(`no shipping`) }}</p>
              </template>
            </b-table>
          </b-card-body>
          <div
            class="d-flex align-items-center justify-content-between p-0 mt-2"
          >
            <div class="dataTables_length" v-if="totalRows > minPerPage">
              <label class="d-flex align-items-center m-0">
                Show
                <b-form-select
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                  class="mx-2"
                ></b-form-select>
              </label>
            </div>

            <b-pagination
              v-if="perPage !== 'All' && totalRows > perPage"
              class="pagination mb-0 justify-content-end"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              size="sm"
            >
              <template v-slot:page="{ page, active }">
                <b v-if="active">{{ page }}</b>
                <i v-else>{{ page }}</i>
              </template>
            </b-pagination>
          </div>

          <!-- end card -->
        </b-card>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
